import { createAsyncThunk } from "@reduxjs/toolkit";
import { surveyAPI } from "services/swagger-api/surveyApi";
import { GetSurveysRequest } from 'api/survey';
import { mapSurveyEligibilityRules, mapSurveyQuestionsToGenericQuestionGroups } from "../mappers/surveyMapper";
import { ProfilingMode } from "features/subscription-process/profiling-process/slices/types/enums";

export const fetchSurveyByContextId = createAsyncThunk(
  'subscriptionProcess/fetchSurveyByContextId',
  async ({ surveyName, surveyCode, request, profilingMode }: { surveyName: string, surveyCode?: string, request: GetSurveysRequest, profilingMode: ProfilingMode }) => {
    const surveys = await surveyAPI.getSurveys(request);
    // Resolve by stable code when provided, fall back to the display name
    const survey = (surveyCode ? surveys.items?.find(item => item.code === surveyCode) : undefined)
      ?? surveys.items?.find(item => item.name === surveyName)
    if (survey && survey.id) {
      const requestQuestions = await surveyAPI.getSurveyQuestions({ id: survey.id })
      return {
        profilingMode,
        questionsGroups: mapSurveyQuestionsToGenericQuestionGroups(requestQuestions),
        eligibilityRules: mapSurveyEligibilityRules(requestQuestions)
      }
    }
  }
);
